import React from 'react'
import { Box, Stack, Typography } from "@mui/material"
import CalificacionA from '../images/alto.png'
import CalificacionB from '../images/navegante-estelar.svg'
import CalificacionC from '../images/navegante-digital.svg'
import CalificacionD from '../images/explorador.svg'
import colors from '../theme/colors'
import { t } from 'i18next'
import { useColors } from '../hooks/useColors'
import { CalificationWithImageAndText } from './commons/CalificationWithImageAndText'

export const AllCalificationsWithImageAndText = ({ width, grafico }) => {

    const { getCalificationColor } = useColors()

    return (
        <Stack direction="column" flex="1" height="50%" marginTop={7} alignItems="flex-end" justifyContent="space-between">
            <CalificationWithImageAndText calification={'A'} width={width} grafico={grafico}/>
            <CalificationWithImageAndText calification={'B'} width={width} grafico={grafico}/>
            <CalificationWithImageAndText calification={'C'} width={width} grafico={grafico}/>
            <CalificationWithImageAndText calification={'D'} width={width} grafico={grafico}/>
        </Stack>
    )
}
